import { AxiosResponse } from 'axios';
import { FEES } from 'shared/types/marketplacePayment';
import { apiV2 } from './http';
import { ConfigCatalogResponse, ConfigPayload } from './interfaces/config';

export function listConfigCatalog(): Promise<
  AxiosResponse<ConfigCatalogResponse>
> {
  return apiV2.get('config-catalog/list');
}

export function searchConfigs(
  idi: number,
): Promise<AxiosResponse<{ status: boolean; configs: ConfigPayload[] }>> {
  return apiV2.get(`installation/app/${idi}/config`);
}

export function editConfig(
  idi: string,
  payload: {
    name: string;
    value: boolean | number | string;
    customerId?: number;
    marketplaceFeesOld?: FEES[];
    yoogaAdditionalTaxId?: number;
  },
): Promise<
  AxiosResponse<{
    status: boolean;
    message: string;
    configs: { name: string; value: boolean | number | string }[];
  }>
> {
  return apiV2.put(`installation/app/${idi}/config`, payload);
}
